export default function () {
	return {
		link: (scope, element, attributes) => {
			// Fixes Chrome bug: https://groups.google.com/forum/#!topic/angular/6NlucSskQjY
			element.prop('method', 'POST');

			// Fix autofill issues where Angular doesn't know about autofilled inputs
			if (attributes.ngSubmit) {
				setTimeout(() => {
					element
						.unbind('submit')
						.submit((event) => {
							event.preventDefault();

							element.find('input, textarea, select')
							       .trigger('input')
							       .trigger('change')
							       .trigger('keydown');

							scope.$apply(attributes.ngSubmit);
						});
				}, 0);
			}
		},
	};
};


// WEBPACK FOOTER //
// ./src/js/directives/formAutofillFix.js